
export default {
    props: ['mod', 'error', 'solid', 'disabled', 'submit', 'to'],
    computed: {
        classObject(){
            return {
                'btn_big': this.mod === 'big',
                'btn_small': this.mod === 'small',
                'btn_solid': this.solid,
                'btn_error': this.error,
            }
        }
    }
}
